import React, { useState, useEffect } from 'react'
import classes from '../../styles/productcarousel.module.css'
import ListItem from '../product/list-item';

async function getProduct(filter, key, exp) {
    const response = await fetch(process.env.NEXTAUTH_URL + "/api/getproduct", {
        method: "POST",
        body: JSON.stringify({ filters: filter, key: key, exp: exp }),
        headers: {
            "Content-Type": "application/json",
        },
    });
    const data = await response.json();
    if (!response.ok) {
        return data;
    }
    return data;
}

function ProductCarouselM(props) {
    const [products, setProduct] = useState([]);
    const [storeid, setStoreId] = useState([]);
    const skulist = (props.skulist) ? props.skulist : [];

    useEffect(() => {
        const ProductData = getProduct({ sku: { in: skulist } }, 'relatedproduct_' + props?.slug, 86400 * 7);
        const response = async () => {
            try {
                const tmp = await ProductData;
                if (tmp && tmp.data) {
                    setProduct(tmp.data?.products?.items);
                    setStoreId(tmp.data?.storeConfig.id)
                }
            } catch (error) {
                console.log('error', error);
            }
        };
        response();
    }, [props?.slug]);

    const homeOrder = (props.type && props.type == 'home_order') ? true : false;

    const heading = props.heading;
    const seeAll = <a href={props.seeAllLink} className={classes['icon-see']}>See All </a>;
    const seeAllData = (props.noSeeAll) ? '' : seeAll;
    if (!skulist.length > 0) {
        return null
    }
    return (
        <div className="pdp-sec19">
            <div className={classes['pdp-sec11']}>
                <div className={classes['journal-colm']}><h2>{heading}</h2>
                    {seeAllData}
                </div>
                <div className={`row ` + classes['row']}>

                    {products.slice().sort((a, b) => a.stock_status.localeCompare(b.stock_status)).map((product) => (
                        <ListItem
                            key={product.id}
                            storeid={storeid}
                            id={product.id}
                            name={product.name}
                            sku={product.sku}
                            description={product.short_description.html}
                            slug={product.slug}
                            image={product.small_image.url}
                            url_path={'/' + product.url_key}
                            url_key={product.url_key}
                            price={product.price.regularPrice.amount.value}
                            mprice={product.price_range.minimum_price.regular_price.value}
                            type={product.type_id}
                            conf={product.configurable_options}
                            variants={product.variants}
                            stock={product.stock_status}
                            categories={product?.categories}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProductCarouselM;